/**
 * The Suspense fallback for a lazily-loaded route.
 *
 * A fixed-height block rather than a spinner, per coding-standards §3.2: a spinner gives no hint
 * of the shape that is coming, and a zero-height fallback makes the page jump when the real
 * content arrives. `aria-busy` is what makes the wait perceivable to a screen reader, which a
 * purely visual skeleton is not.
 */
export function RouteSkeleton() {
    return (
        <div
            aria-busy="true"
            aria-live="polite"
            style={{
                minHeight: 'var(--et-layout-skeleton-block)',
                borderRadius: 'var(--et-radius-lg)',
                // §5's loading state: skeleton blocks are surface/card-warm.
                background: 'var(--et-surface-card-warm)',
                border: '1px solid var(--et-border-card)',
            }}
        >
            <span
                style={{
                    display: 'block',
                    padding: 'var(--et-space-6)',
                    color: 'var(--et-text-secondary)',
                    fontSize: 'var(--et-type-secondary-size)',
                }}
            >
                Loading…
            </span>
        </div>
    );
}
